import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _slice from "lodash/slice";
import _sum from "lodash/sum";
import _map from "lodash/map";
import _noop from "lodash/noop";
import _identity from "lodash/identity";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import { PressableContext } from "../Pressable";
import autocorrect from "../lib/autocorrect";

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input() {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this);
    _this.inputElement = void 0;
    _this.selection = void 0;
    _this.composing = void 0;

    _this.inputRef = function (inputElement) {
      _this.inputElement = inputElement;
    };

    _this.handleBlur = function (e) {
      _this.setState({
        focused: false
      });

      _this.props.onBlur && _this.props.onBlur(e);
    };

    _this.handleFocus = function (e) {
      _this.setState({
        focused: true
      });

      _this.props.onFocus && _this.props.onFocus(e);
    };

    _this.handleChange = function (e) {
      _this._handleChange(e.target.value);
    };

    _this._handleChange = function (rawValue) {
      if (_this.composing) {
        _this.setState({
          composition: rawValue
        });
      } else if (_this.inputElement) {
        var _this$props = _this.props,
            autocorrectPattern = _this$props.autocorrectPattern,
            onChange = _this$props.onChange,
            beforeAutocorrect = _this$props.beforeAutocorrect;
        var target = _this.inputElement; // setSelectionRange only applicable for certain inputs
        // https://html.spec.whatwg.org/multipage/input.html#do-not-apply

        var selectionStart;
        var selectionEnd;
        var selectable = ['text', 'tel', 'url', 'password'].indexOf(target.type) >= 0;

        if (selectable) {
          selectionStart = target.selectionStart;
          selectionEnd = target.selectionEnd;
        }

        if (!autocorrectPattern) {
          onChange && onChange(rawValue);
          return;
        }

        var deleting = rawValue.length < (_this.props.value || '').length;
        var preformatted = beforeAutocorrect(rawValue, deleting);

        if (Array.isArray(preformatted)) {
          if (selectable) {
            var preformattedLengths = _map(preformatted, function (s) {
              return s.length;
            });

            selectionStart = _sum(_slice(preformattedLengths, 0, selectionStart));
            selectionEnd = _sum(_slice(preformattedLengths, 0, selectionEnd));
          }

          preformatted = preformatted.join('');
        }

        var transformed = autocorrect.transformInput(autocorrectPattern, preformatted, !deleting);

        if (selectable) {
          var lengths = _map(transformed, function (s) {
            return s.length;
          });

          selectionStart = _sum(_slice(lengths, 0, selectionStart));
          selectionEnd = _sum(_slice(lengths, 0, selectionEnd));
          _this.selection = {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
          };
        }

        onChange && onChange(transformed.join(''));
      }
    };

    _this.handleCompositionStart = function (e) {
      // Predictive typing systems, including Japanese IME, Chinese IME, and
      // mobile keyboard predictive keyboards, behave poorly with naive
      // controlled-input masking system. The interaction of the predictive typing
      // with React events depends on a combination of operating system, browser,
      // and virtual keyboard.
      //
      // To avoid issues with selectionStart during the composition and to avoid
      // other issues that come with interefering with the composition (such as
      // the keyboard switching back to the alpha-view when it was set to numerical
      // by the user), we embrace composition mode in those cases, and only
      // format after composition ends.
      _this.composing = true;
    };

    _this.handleCompositionUpdate = function (e) {
      // Android Chrome with various keyboards (e.g. the default GBoard) switches
      // into composition mode when backspacing through composed input parts
      // without emitting a compositionStart event. In that case we toggle
      // composition mode here. This behavior seems to have been fixed in Chrome 66.
      if (!_this.composing) {
        _this.composing = true;
      }
    };

    _this.handleCompositionEnd = function (e) {
      // If we do not support composition events on this browser and hence did not
      // switch into composition mode, return early.
      if (!_this.composing) {
        return;
      }

      var val = e.target.value; // In Firefox, there will be a change event after compositionEnd
      // This change event will have the value '' if the the current
      // value of the field has already changed.
      // So executing the following `handleChange` right away could
      // lead to reformatting of the value and hence putting an unexpected
      // value in the field and then losing that value due to the upcoming
      // change event having the value ''.
      // Waiting until after that change event solves this issue.
      // Update: Firefox 60 seems to not be impacted by this, so we can
      // probably remove it at some point (not sure when exactly it was fixed).

      setTimeout(function () {
        // We'll only do this if we detect it's probably necessary to avoid
        // Android/Gboard issue mentioned below.
        if (_this.inputElement && _this.inputElement.value === '' && val) {
          _this._handleChange(val);
        }
      }, 0); // We need to do this immediately for new Android/Gboard. Not doing
      // it immediately results in composition mode immediately being re-entered
      // after hitting 'space' which makes it difficult to input multi-word strings
      // https://jira.corp.stripe.com/browse/DASH-6286

      _this.composing = false;

      _this.setState({
        composition: ''
      });

      _this._handleChange(val);
    };

    _this.state = {
      focused: false,
      composition: null
    };
    _this.selection = null;
    _this.composing = false;
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoSelect) {
        this.select();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.focused && prevState.focused && this.selection) {
        var _this$selection = this.selection,
            selectionStart = _this$selection.selectionStart,
            selectionEnd = _this$selection.selectionEnd;
        this.selection = null;
        /**
         * We set the selection range both before and after the render (via setTimeout).
         * Most platforms respect the selection state set here after the render.
         *
         * In e.g. IE9/IE10 and Chrome 56/Samsung keyboard, the cursor will not
         * advance past formatting characters unless setSelectionRange happens after render.
         *
         * However, if we set selection range after render for every platform, the cursor will jump.
         *
         * So, let's do both. It's a no-op for most platforms, and allows for a jumpy fix for
         * the others.
         *
         * (Fix borrowed from: https://git.corp.stripe.com/stripe-internal/stripe-js-v3/pull/210/files)
         */

        if (this.inputElement) {
          this.inputElement.setSelectionRange(selectionStart, selectionEnd);
        }

        setTimeout(function () {
          if (_this2.inputElement) {
            _this2.inputElement.setSelectionRange(selectionStart, selectionEnd);
          }
        }, 0);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.inputElement && this.inputElement.focus();
    }
  }, {
    key: "select",
    value: function select() {
      this.inputElement && this.inputElement.select();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.inputElement && this.inputElement.blur();
    }
  }, {
    key: "node",
    value: function node() {
      return this.inputElement;
    }
  }, {
    key: "inputType",
    value: function inputType() {
      return this.props.sensitive && !this.state.focused ? 'password' : this.props.type;
    } // Taken from https://git.corp.stripe.com/stripe-internal/stripe-js-v3/blob/f013a7e926bda93cdb06145e992bc90b2cba7e6d/src/elements/inner/shared/components/Input.js#L272-L299

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          ariaDescribedBy = _this$props2['aria-describedby'],
          ariaLabel = _this$props2['aria-label'],
          ariaLabelledBy = _this$props2['aria-labelledby'],
          autocorrectPattern = _this$props2.autocorrectPattern,
          autoSelect = _this$props2.autoSelect,
          beforeAutocorrect = _this$props2.beforeAutocorrect,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          multiline = _this$props2.multiline,
          required = _this$props2.required,
          sensitive = _this$props2.sensitive,
          value = _this$props2.value,
          inputProps = _objectWithoutProperties(_this$props2, ["aria-describedby", "aria-label", "aria-labelledby", "autocorrectPattern", "autoSelect", "beforeAutocorrect", "className", "disabled", "multiline", "required", "sensitive", "value"]);

      var actualValue = this.composing ? this.state.composition : value;

      var props = _objectSpread({}, inputProps, {
        'aria-describedby': ariaDescribedBy,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledBy,
        'aria-required': required && 'true',
        value: actualValue,
        type: this.inputType(),
        ref: this.inputRef,
        required: required,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onCompositionStart: this.handleCompositionStart,
        onCompositionEnd: this.handleCompositionEnd,
        onCompositionUpdate: this.handleCompositionUpdate
      });

      return /*#__PURE__*/React.createElement(PressableContext.Consumer, null, function (_ref) {
        var pressableContextClasses = _ref.pressableContextClasses,
            width = _ref.width;
        var classes = classNames('Input', {
          'Input--nowrap': !multiline
        }, pressableContextClasses, className);
        return multiline ? /*#__PURE__*/React.createElement("textarea", _extends({}, props, {
          className: classes,
          disabled: disabled
        })) : /*#__PURE__*/React.createElement("input", _extends({}, props, {
          className: classes,
          disabled: disabled
        }));
      });
    }
  }]);

  return Input;
}(React.Component);

Input.defaultProps = {
  autocorrectPattern: null,
  beforeAutocorrect: _identity,
  className: '',
  multiline: false,
  onBlur: _noop,
  onChange: _noop,
  onFocus: _noop,
  placeholder: '',
  sensitive: false,
  type: 'text'
};
export default Input;